//react imports
import * as React from 'react';

//components
import LeadImage from '../components/LeadImage.jsx';

//images
import development from '../assets/img/sections/development.jpeg';

const Development = () => {
  return (
    <section className="section" id="housing-and-development">
      <div className="wrapper" id="housingdevwrapper">
        <LeadImage
          image={development}
          text={
            'Vigilante Coffee opened on Route 1 in March. It replaces #1 Liquors. (Photo by Tom Hausman/The Diamondback)'
          }
        />

        <h1>Development</h1>
        <h3 className="first-line">
          Living and working in the same area: that’s the crux of the
          partnership’s housing and redevelopment strategy. By creating more
          “vibrant” amenities and offering forgivable loans to attract city and
          university employees to live in the area, the partnership seeks to
          create a sustainable, year-long economy. Leaders say the strategy will
          also reduce traffic and carbon emissions.
        </h3>
        <p>
          As part of Maryland’s Regional Institution Strategic Enterprise Zone
          program, businesses now receive tax incentives for locating in certain
          areas of College Park, including the M Square Research Park and part
          of the Route 1 corridor, according to the partnership’s website. The
          RISE Zone status is valid up to five years.
          <br />
          <br />
          “This is one of the hottest areas of development,” university
          President Wallace Loh said.
          <br />
          <br />
          But critics have argued that the focus on attracting new residents and
          businesses has detracted from the experience of current residents and
          students. Some have also posed that the new amenities make the city
          more expensive and urbanized than a true college town should be.
        </p>

        <h3 className="list-heading">Accomplisments To Date</h3>

        <p className="p-heading">The Hotel at the University of Maryland</p>
        <p className="descrip">
          The $180 million project, which opened in September 2017, functions as
          a mixed-use building. The city’s only four-star hotel, it offers
          conference facilities, a bar and “high-end” restaurants such as Old
          Maryland Grill and Kapnos Taverna on the ground floor.
          <br />
          <br />
          Company offices housed in the Diamondback Garage behind The Hotel will
          include Capital One, Immuta, BlueVoyant and a shared space with the Do
          Good accelerator — which provides leadership coaching and mentoring
          opportunities to students developing nonprofits and other
          philanthropic projects — and will be completed in July creating even
          more jobs, Ulman said.
          <br />
          <br />
          Its opening also added 850 garage parking spots to the city.
        </p>

        <p className="p-heading">Vigilante Coffee</p>
        <p className="descrip">
          Vigilante Coffee opened in March 2018, replacing #1 Liquors. Ulman
          described the old space as “dumpy looking,” and said this new addition
          makes the area more vibrant for students, residents and visitors.
          <br />
          <br />
          “When I ask people what a great college town has, the first or second
          thing out of their mouth is good coffee shops,” Ulman said.
          <br />
          <br />
          The cafe’s signature items include specialty coffees, seasonal acai
          bowls and fresh pastries. It provides free WiFi to customers several
          days of the week.
        </p>

        <p className="p-heading">MilkBoy ArtHouse</p>
        <p className="descrip">
          Former College Park Mayor Andrew Fellows described MilkBoy ArtHouse as
          a “physical manifestation of the new.” The joint restaurant and
          performing arts venue opened in May 2017 and allows some student
          groups to perform and hold pay-to-enter events.
          <br />
          <br />
          Eric Olson, the partnership’s executive director, said a grant award
          helped fund the “facade improvements.” The partnership worked with the
          university’s Clarice Smith Performing Arts Center to obtain a tax
          credit for donors who support MilkBoy programming.
          <br />
          <br />
          John Hedrick, a rising senior, said while Milkboy Arthouse stands out
          in College Park as a “really cool” venue that’s unique to the area,
          not all undergraduate students can take full advantage of it.
          <br />
          <br />
          “Events can be kind of expensive,” the psychology major said. “And,
          I’m only 20, so I’m not into the bar scene yet.”
        </p>

        <p className="p-heading">
          Homeownership Program through the Maryland Department of Housing and
          Community Development’s Community Legacy Grant
        </p>
        <p className="descrip">
          The program awards $15,000 in deferred-payment, forgivable loans for
          university or city employees to use on their down payments and closing
          costs. The loan requires recipients to live within the city limits of
          College Park for 10 years, or otherwise repay the loan.
          <br />
          <br />
          Olson said that so far, the program has attracted 36 new home buyers.
          He also said the program enables staffers to spend more time in the
          community, reducing their commutes and strengthening the
          neighborhoods.
          <br />
          <br />
          “If they are going to help us with a down payment, might as well take
          it,” said homebuyer Laura McGrath Hood, an employee of this
          university.
          <br />
          <br />
          Loh said about four percent of faculty and staff lived in College Park
          when he arrived at this university, and he expects the area to attract
          as many as 7,000 more residents, both affiliated and non-affiliated
          with the university, over the next few years.
        </p>

        <p className="p-heading">Midtown Revitalization study</p>
        <p className="descrip">
          A redevelopment study was completed last year to help inform
          developers of the “possibilities for redevelopment” in the Midtown
          area, Olson said.
          <br />
          <br />
          The study found that there is a high concentration of fast dining and
          convenience stores. Development should instead focus on “specialty
          retail products and creating an authentic sense of place,” according
          to the report.
          <br />
          <br />
          <span>Major student housing/mixed use projects</span>
          <br />
          <br />
          Olson said the partnership worked with investors and gave them
          confidence to build the University View, The Enclave, Terrapin Row,
          and other student housing complexes.
          <br />
          <br />
          The Enclave will begin filling its empty retail space in the coming
          months with a new sushi restaurant named LaTAO. Ryan Chelton, College
          Park’s economic development coordinator, said in February that he
          hopes the opening of LaTAO will cause a “chain reaction” and “draw in
          more retail.”
          <br />
          <br />
          A recent housing market survey by this university’s Department of
          Resident Life showed despite all the new apartment buildings springing
          up in the city, most underclassmen at this university still live on
          the campus.
          <br />
          <br />
          “Something continually advocated for by students is more affordable
          housing options,” said AJ Pruitt, this university’s Student Government
          Association president for 2017-18. “That’s something that has been
          somewhat left behind.”
          <br />
          <br />
          <span>Opening of mixed-use housing project for professionals</span>
          <br />
          <br />
          Olson said Domain, which opened in June 2013, was primarily built to
          serve young professionals. When constructed, the Domain was the first
          non-student apartment complex built in the city since 2007. In its
          first year open, The Diamondback reported that most Domain residents
          were professionals who didn’t have any connection to the university.
          <br />
          <br />
          Rent for the Domain starts at $1,686/month for a one-bedroom,
          one-bathroom unit, according to its website.
          <br />
          <br />
          But some College Park residents said they have never considered the
          Domain as a legitimate option.
          <br />
          <br />
          “I was just floored when I saw what it was going to cost. For a family
          with a couple young kids, there was no way in the world that was
          something we could consider,” said resident Jennifer Haislip.
          <br />
          <br />
          Leaders of the partnership have also expressed a desire to provide
          more graduate student housing in the coming years.
        </p>

        <h3 className="list-heading">
          Highlights of the Redevelopment 2018 Work Plan
        </h3>

        <p className="p-heading">Redevelop City Hall</p>
        <p className="descrip">
          In March, the College Park City Council voted 6-2 to buy two
          properties near the intersection of Knox Road and Route 1 in an effort
          to redevelop City Hall. The $1.6 million purchase of these properties,
          7409 and 7411 Baltimore Ave., will displace current tenants Shanghai
          Cafe and Subway. Olson said City Hall will benefit from more office
          space and mixed-use redevelopment, and construction will not finish
          before 2020.
          <br />
          <br />
          The city has received pushback from residents at this plan. At a
          November public hearing, many residents said the city should not take
          over the properties through the right of eminent domain.
          <br />
          <br />
          Wojahn told The Diamondback in March that the city would help the
          businesses relocate when their leases expire in September 2019.
          <br />
          <br />
          “It’s not really anything that we particularly have to do,” Wojahn
          said, “but since we want to support local businesses, we are willing
          to work with them on reasonable relocation expenses.”
          <br />
          <br />
          Smoothie King and Hair Cuttery — located at 7403 and 7405 Baltimore
          Ave., respectively — are in talks to be relocated as well, Ulman told
          The Diamondback in March.
        </p>

        <p className="p-heading">
          Koons Ford property demolished to make way for redevelopment
        </p>
        <p className="descrip">
          The demolition paves the way for Cambria Hotel & Suites to open in
          2018, which will feature the College Park Grill on its ground level.
          Grill owner Adam Greenberg described the restaurant in November 2017
          as targeting residents, professors and businesspeople.
          <br />
          <br />
          Greenberg, who also owns Potomac Pizza and Bagels ‘n Grinds, said
          “students are very welcome, but it will be above the usual price range
          of a usual student meal.”
          <br />
          <br />
          The hotel will also feature a parking garage, with live music in the
          restaurant every night.
        </p>

        <p className="p-heading">
          Auto parts store transformed into an upscale restaurant
        </p>
        <p className="descrip">
          “That construction should start any day,” Olson said.
          <br />
          <br />
          Similar to MilkBoy ArtHouse, the restaurant will function as a
          coffeehouse, wine bar and craft beer shop, with a performance space
          upstairs and locally sourced food.
          <br />
          <br />
          Olson said he hopes for a 2018 opening, adding, “There should be some
          activity there this May.”
        </p>

        <p className="p-heading">Computer science building</p>
        <p className="descrip">
          The Brendan Iribe Center for Computer Science and Innovation, still
          undergoing construction, is slated to open by the end of 2018. The
          project cost about $152 million.
          <br />
          <br />
          Prince George’s County Council Chair Dannielle Glaros stressed the
          significance of the university choosing to build it right on Route 1
          rather than in the center of the campus.
          <br />
          <br />
          “It sends a really strong statement about the university’s connection
          to the city, and it’s helping to anchor future development
          opportunities along that corridor,” Glaros said.
        </p>

        <p className="p-heading">WeWork project</p>
        <p className="descrip">
          WeWork, a workspace and business services provider, will open this
          fall in a building across from the Diamondback Garage.
          <br />
          <br />
          “It’s the kind of facility that will be attractive to student and
          faculty-led startups that are looking for a place to grow their
          company, as they’re moving off of an idea created on campus,” Ulman
          said in March.
        </p>

        <p className="p-heading">The Hall</p>
        <p className="descrip">
          Ulman said The Hall, a restaurant with arts and music venues, will
          open toward the end of this year behind The Hotel.
          <br />
          <br />
          “We’ve been able to open some new facilities — and now every six
          months or year, there’s a few more opening — and we are just building
          on the progress and the momentum,” he said.
        </p>

        <p className="p-heading">
          Bringing university faculty and staff to College Park
        </p>
        <p className="descrip">
          At the site of the Quality Inn and Plato’s Diner — the latter of which
          was gutted by fire in April 2016 — there are plans to build hundreds
          of residential units, as well as retail space and parking. The city
          council voted in January to approve three agreements for the Route 1
          development, but Ulman said they’re still ironing out the details.
          <br />
          <br />
          Ulman said it’s designed to be “housing for faculty and staff who want
          to live closer to campus, but have great amenity options for students
          and non-students.”
          <br />
          <br />
          He added that while student-focused projects like Terrapin Row have
          popped up over recent years, graduate student housing is the next
          priority.
          <br />
          <br />
          “My hope is that we will end up announcing some more housing
          initiatives in the year to come,” he said.
        </p>
      </div>
    </section>
  );
};

export default Development;



// WEBPACK FOOTER //
// ./src/views/Development.jsx